import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    logo: ['#A51C30', '#500E13', '#660000', , '#FF9999', '#FFD6D6'],
    primary: { main: '#A51C30', light: '#FF9999', dark: '#500E13' },
    purple: ['#CB91F2'],
    blue: ['#96BBFF'],
    white: ['#FFF', '#F2F2F2', '#DDDDE3', '#C7C7D1', '#9A9AAC'],
    orange: ['#FFA85C'],
    green: ['#329A5C'],
  },
  typography: {
    fontFamily: ['Roboto'],
    h1: {
      fontFamily: ['Inter'],
      fontWeight: 800
    },
    h2: {
      fontFamily: ['Geologica'],
      fontWeight: 200,
    }
  },
})

theme.typography.h1 = {
  fontSize: '4rem',
  '@media (min-width:800px)': {
    fontSize: '6rem',
  },
};

theme.typography.h2 = {
  fontSize: '1.5rem',
  fontWeight: 200,
  fontFamily: ['Geologica'],
  '@media (min-width:600px)': {
    fontSize: '3rem',
  },
  '@media (min-width:800px)': {
    fontSize: '4.5rem',
  },
};

export default theme
